import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Output,
	EventEmitter
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Accordion, AccordionState } from './definitions';
import { AccordionService } from './accordion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isRaymond } from '../../constants/environment.constant';
@Component({
	selector: 'kng-accordion-component',
	templateUrl: './template/accordion.component.html',
	styleUrls: ['./template/accordion.component.scss'],
	providers: [AccordionService]
})
export class AccordionComponent implements Accordion, OnInit, OnDestroy
{
	private readonly subscriptions: Subscription = new Subscription();
	isRaymond:boolean = false;
	accordionRaymondIcon:string ='/assets/images/accordion_collapsed_raymond.svg';
	@Output() isAccordionClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() stateChanged: EventEmitter<AccordionState> = new EventEmitter<AccordionState>();
	@Output() tooltipClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output() searchDataChange: EventEmitter<string> = new EventEmitter<string>();

	@Input() set state(value: AccordionState)
	{
		this.service.updateState(value);
	}
	isValidZipCode: boolean = true;

	get state(): AccordionState
	{
		return this.service.state;
	}
	constructor(private readonly service: AccordionService, private readonly formBuilder: FormBuilder) { }

	ngOnInit(): void
	{
		this.isRaymond = isRaymond || false;
		this.initSubscriptions();
	}
	ngOnDestroy(): void
	{
		this.destroySubscriptions();
	}

	private initSubscriptions(): void
	{
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
			(next: AccordionState) => this.stateChanged.emit(next)
		);
		this.subscriptions.add(stateChangeSubs);
	}

	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}

	handleHeaderClick(event: Event)
	{
		if (window.innerWidth < 768)
		{
			event.stopPropagation();
		}
	}
	showTooltip()
	{
		this.tooltipClicked.emit();
	}
	accordionClicked(collapsed: boolean)
	{
		this.isAccordionClicked.emit(collapsed);
	}
	clearSearchInput()
	{
		this.isValidZipCode = true;
		this.searchForm.patchValue({
			zipCode: ''
		});
		this.searchDataChange.emit('');
	}
	applysearch(event: KeyboardEvent): void
	{
		const inputElement = event.target as HTMLInputElement;
		if (event.key === ' ' && inputElement.value.length < 7)
		{
			event.preventDefault();
			const cursorPosition = inputElement.selectionStart ?? 0;
			const inputValue = inputElement.value;
			const updatedValue = inputValue.slice(0, cursorPosition) + ' ' + inputValue.slice(cursorPosition);
			inputElement.value = updatedValue;
			this.searchForm.patchValue({
				zipCode: updatedValue
			});

			const newPosition = cursorPosition + 1;
			inputElement.setSelectionRange(newPosition, newPosition);
		}

		if(!inputElement.value.trim().length)
		{
			this.isValidZipCode = true;
		}

		if (event.key === 'Enter')
		{
			this.zipCodeValidator(inputElement.value);
		}
	}
	public searchForm: FormGroup = this.formBuilder.group({
		zipCode: [ '', [ Validators.required, Validators.maxLength(7) ] ]
	});

	zipCodeValidator(searchValue: string): void
	{
		const pattern = /^[A-Za-z0-9\s-]*$/;
		if(!pattern.test(searchValue))
		{
			this.isValidZipCode = false;
		}
		this.isValidZipCode = this.isValidUSPostalCode(searchValue) || this.isValidCanadianPostalCode(searchValue);

		if (searchValue.length >= 5 && this.isValidZipCode)
		{
			const searchData = searchValue.trim();
			this.searchDataChange.emit(searchData);
		}
	}

	isValidLength(searchValue: string, isUSCode: boolean = false): boolean
	{
		const strippedValue = searchValue.replace(/\s/g, '');
		const length = strippedValue.length;

		if(isUSCode)
		{
			return length === 5;
		}
		else
		{
			return length === 6 || length === 7;
		}
	}

	isValidUSPostalCode(searchValue: string): boolean
	{
		return this.isValidLength(searchValue, true) && /^\d+$/.test(searchValue.trim());
	}

	isValidCanadianPostalCode(searchValue: string): boolean
	{
		const strippedValue = searchValue.replace(/\s/g, '');
		if(strippedValue.trim().length === 7 && searchValue.trim().length < 8)
		{
			if(/^[A-Za-z0-9\s-]*$/.test(searchValue))
			{
				return true;
			}
			return false;
		}
		else
		{
			return this.isValidLength(searchValue, false) && /^[A-Za-z0-9]{3}[-\s][A-Za-z0-9]{3}$/.test(searchValue.trim());
		}
	}
}
